<template>
  <div class="hiver-branding-widget" v-if="hiverConfig.show_hiver_branding">
    <img
      class="hiver-branding-widget__logo"
      src="~widget/assets/images/hiver.svg"
      alt=""
    />
    <span
      class="hiver-branding-widget__content"
      @click="redirectToHiverHelpTab"
    >
      Powered by <strong>Hiver</strong>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HIVER_HELP_URL } from '../helpers/constants';

export default {
  computed: {
    ...mapGetters({
      hiverConfig: 'hiverConfig/getHiverConfig',
    }),
  },
  methods: {
    redirectToHiverHelpTab() {
      window.open(HIVER_HELP_URL, '_blank', 'noopener');
    }
  },
};
</script>
<style lang="scss" scoped>
@import '~widget/assets/scss/variables.scss';
.hiver-branding-widget {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 0 14px 0;
  color: #6c7b94;
  &__logo {
    margin-right: 5px;
  }
  &__content {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.214286px;
    cursor: pointer;
  }
}
</style>
